module.exports = __webpack_public_path__ + "static/media/pixiv54839592.b4fa00d6.png";